// extracted by mini-css-extract-plugin
export default {"TableauBootstrap":"ModifierComposante_TableauBootstrap__JgUhc","btn_stylo":"ModifierComposante_btn_stylo__t4gLE","center":"ModifierComposante_center__Mggl+"};